// src/pages/SuccessStoriesPage.jsx
import React from 'react';
import PageHeader from './PageHeader'; // Adjust path if needed
import { useLanguage } from '../../context/LanguageContext'; // Adjust path if needed

const SuccessStoriesPage = () => {
  const { language } = useLanguage();

  const t = {
    English: {
      pageHeaderTitle: "Success Stories",
      mainTitle: "Happy Success Stories",
      highlighted: "Success Stories",
      subtitle: "Read about the beautiful journeys of couples who found their perfect life partners through Kalyana Matrimony. These real stories inspire hope and celebrate love rooted in trust and compatibility.",
      marriedOn: "Married on:",
      stories: [
        {
          id: 1,
          names: "Arun & Priya",
          image: "https://images.pexels.com/photos/15748379/pexels-photo-15748379/free-photo-of-smiling-couple-in-traditional-clothing.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
          story: "We met on Kalyana Matrimony in January 2023. Priya's profile caught my attention with her genuine details and family values. I sent an interest, and she accepted promptly. We started chatting and discovered so many shared interests – from love for South Indian cuisine to similar career goals. Our families connected beautifully during the first meeting. Kalyana Matrimony's verified profiles and privacy features gave us complete confidence. Today, we're happily married and grateful for this wonderful platform that brought us together. Thank you Kalyana Matrimony for helping me find my soulmate!",
          date: "15th August 2023"
        },
        {
          id: 2,
          names: "Karthik & Divya",
          image: "https://media.istockphoto.com/id/1560030247/photo/happy-young-couple-with-traditional-ethnic-wear-looking-camera-by-holding-sweets-and-pooja.jpg?s=612x612&w=0&k=20&c=GWh8SFLRB9mD6hQkFaFzAbf2KEZ7YwLb3h8NshckMNk=",
          story: "I was skeptical about online matrimony sites until I joined Kalyana Matrimony. Divya's profile stood out because of the detailed preferences and the verification badge. We matched on education, profession, and family background. After weeks of meaningful conversations, we realized we were perfect for each other. The platform's smart matching algorithm truly worked wonders. Our engagement was fixed within months, and now we're enjoying married life. I highly recommend Kalyana Matrimony to anyone looking for a genuine life partner!",
          date: "22nd October 2023"
        },
        {
          id: 3,
          names: "Rahul & Meera",
          image: "https://www.nishantratnakar.com/wp-content/uploads/2019/01/Konkani-Tamil-Wedding-Cover-Photo-0002.jpg",
          story: "As doctors, finding someone who understands the demands of our profession was challenging. Kalyana Matrimony's advanced occupation and education filters helped me find Meera instantly – she was also a doctor with similar values. We connected over shared experiences and long-duty stories. The secure chat and privacy controls made our interactions comfortable. Our families approved wholeheartedly, and we tied the knot in a beautiful ceremony. Kalyana Matrimony isn't just a site; it's a bridge to lifelong happiness. Best platform for professionals seeking meaningful connections!",
          date: "10th December 2023"
        },
        {
          id: 4,
          names: "Suresh & Lakshmi",
          image: "https://thumbs.dreamstime.com/b/happy-indian-married-couple-traditional-happy-indian-married-couple-traditional-wedding-clothes-looking-each-other-225141648.jpg",
          story: "Lakshmi and I come from traditional Tamil families, and Kalyana Matrimony respected our cultural preferences perfectly. Her profile highlighted horoscope compatibility, which was important to our parents. After exchanging interests and photos securely, we met in person and felt an instant connection. The platform's support team was helpful throughout. We're now blessed with a happy married life and often recommend Kalyana Matrimony to friends and family.",
          date: "5th February 2024"
        }
      ]
    },
    Tamil: {
      pageHeaderTitle: "வெற்றிக் கதைகள்",
      mainTitle: "மகிழ்ச்சியான வெற்றிக் கதைகள்",
      highlighted: "வெற்றிக் கதைகள்",
      subtitle: "Kalyana Matrimony மூலம் தங்கள் வாழ்க்கைத் துணையைக் கண்டறிந்த தம்பதிகளின் அழகிய பயணங்களைப் படியுங்கள். நம்பிக்கை மற்றும் இணக்கத்துடன் கூடிய காதலை கொண்டாடும் இந்த உண்மைக் கதைகள் ஊக்கமளிக்கின்றன.",
      marriedOn: "திருமண தேதி:",
      stories: [
        {
          id: 1,
          names: "அருண் & பிரியா",
          image: "https://images.pexels.com/photos/15748379/pexels-photo-15748379/free-photo-of-smiling-couple-in-traditional-clothing.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
          story: "நாங்கள் Kalyana Matrimony-இல் 2023 ஜனவரியில் சந்தித்தோம். பிரியாவின் சுயவிவரம் அதன் உண்மையான விவரங்களும் குடும்ப மதிப்புகளும் என்னை கவர்ந்தன. நான் ஆர்வம் காட்டினேன், அவர் உடனடியாக ஏற்றுக்கொண்டார். பேசத் தொடங்கியதும், தென்னிந்திய உணவு முதல் தொழில் இலக்குகள் வரை பல ஒற்றுமைகளைக் கண்டோம். முதல் சந்திப்பில் எங்கள் குடும்பங்கள் அற்புதமாக இணைந்தன. சரிபார்க்கப்பட்ட சுயவிவரங்களும் தனியுரிமையும் எங்களுக்கு முழு நம்பிக்கை அளித்தன. இன்று நாங்கள் மகிழ்ச்சியான திருமண வாழ்க்கை வாழ்கிறோம். என் ஆன்ம துணையைக் கண்டறிய உதவிய Kalyana Matrimony-க்கு நன்றி!",
          date: "15 ஆகஸ்ட் 2023"
        },
        {
          id: 2,
          names: "கார்த்திக் & திவ்யா",
          image: "https://media.istockphoto.com/id/1560030247/photo/happy-young-couple-with-traditional-ethnic-wear-looking-camera-by-holding-sweets-and-pooja.jpg?s=612x612&w=0&k=20&c=GWh8SFLRB9mD6hQkFaFzAbf2KEZ7YwLb3h8NshckMNk=",
          story: "ஆன்லைன் திருமண தளங்களை நான் சந்தேகத்துடன் பார்த்தேன், ஆனால் Kalyana Matrimony-இல் சேர்ந்த பிறகு திவ்யாவின் சுயவிவரம் தனித்து நின்றது. கல்வி, தொழில், குடும்ப பின்னணியில் பொருந்தினோம். வாரங்களுக்கு பொருளுள்ள உரையாடல்களுக்குப் பிறகு நாங்கள் பரிபூரண இணை என்பதை உணர்ந்தோம். புத்திசாலி இணைத்தல் அல்காரிதம் அற்புதமாக வேலை செய்தது. சில மாதங்களிலேயே நிச்சயதார்த்தம் நடந்தது. இப்போது திருமண வாழ்க்கையை அனுபவிக்கிறோம். உண்மையான துணையைத் தேடுபவர்களுக்கு Kalyana Matrimony-ஐ பரிந்துரைக்கிறேன்!",
          date: "22 அக்டோபர் 2023"
        },
        {
          id: 3,
          names: "ராகுல் & மீரா",
          image: "https://www.nishantratnakar.com/wp-content/uploads/2019/01/Konkani-Tamil-Wedding-Cover-Photo-0002.jpg",
          story: "டாக்டர்களாக, எங்கள் தொழிலின் கோரிக்கைகளைப் புரிந்துகொள்ளும் ஒருவரைக் கண்டறிவது கடினமாக இருந்தது. Kalyana Matrimony-இன் தொழில் மற்றும் கல்வி வடிகட்டிகள் மீராவைக் உடனடியாகக் கண்டறிய உதவின – அவரும் டாக்டர். பகிர்ந்த அனுபவங்களால் இணைந்தோம். பாதுகாப்பான அரட்டையும் தனியுரிமையும் வசதியாக இருந்தது. குடும்பங்கள் முழு ஆதரவளித்தன. அழகிய விழாவில் திருமணம் செய்தோம். Kalyana Matrimony வாழ்நாள் மகிழ்ச்சிக்கான பாலம். தொழில்முறையாளர்களுக்கு சிறந்த தளம்!",
          date: "10 டிசம்பர் 2023"
        },
        {
          id: 4,
          names: "சுரேஷ் & லட்சுமி",
          image: "https://thumbs.dreamstime.com/b/happy-indian-married-couple-traditional-happy-indian-married-couple-traditional-wedding-clothes-looking-each-other-225141648.jpg",
          story: "லட்சுமியும் நானும் பாரம்பரிய தமிழ் குடும்பங்களைச் சேர்ந்தவர்கள். Kalyana Matrimony எங்கள் கலாச்சார விருப்பங்களை மதித்தது. ஜாதக பொருத்தம் முக்கியமாக இருந்தது. ஆர்வமும் புகைப்படங்களும் பாதுகாப்பாக பரிமாறிய பிறகு நேரில் சந்தித்தோம், உடனடி இணைப்பு ஏற்பட்டது. ஆதரவு குழு உதவிகரமாக இருந்தது. இப்போது மகிழ்ச்சியான திருமண வாழ்க்கை வாழ்கிறோம். நண்பர்களுக்கு Kalyana Matrimony-ஐ பரிந்துரைக்கிறோம்.",
          date: "5 பிப்ரவரி 2024"
        }
      ]
    }
  };

  const txt = t[language];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        showBackButton={true} 
        backTo="/" 
        title={txt.pageHeaderTitle} 
      />

      <div className="container mx-auto px-6 py-16">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 mb-6 leading-tight">
            {txt.mainTitle.replace(txt.highlighted, '')}
            <span className="text-rose-600"> {txt.highlighted}</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
            {txt.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10 max-w-5xl mx-auto">
          {txt.stories.map(story => (
            <div
              key={story.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden border border-rose-50 hover:shadow-2xl transition-all duration-300 flex flex-col"
            >
              <div className="h-80 overflow-hidden">
                <img
                  src={story.image}
                  alt={`${story.names} - Happy Couple`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-8 flex-1 flex flex-col">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
                  {story.names}
                </h3>
                <p className="text-rose-600 font-semibold text-base mb-6">
                  {txt.marriedOn} {story.date}
                </p>
                <p className="text-gray-700 italic leading-relaxed text-base flex-1">
                  "{story.story}"
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessStoriesPage;